import { Pressable, Text, View } from 'react-native'
import { SheetManager, type SheetProps } from 'react-native-actions-sheet'
import { useTranslation } from 'react-i18next'

import { cn } from '@/utils/cn'
import { Camera, Close, Image } from '@/components/icon'

import { BottomSheet } from './BottomSheet'

export function SelectImageSheet(props: SheetProps<'select-image'>) {
  const { t } = useTranslation()
  function handleOpenImageViewer() {
    SheetManager.hide(props.sheetId)
    setTimeout(() => {
      props.payload?.openImageViewer()
    }, 300)
  }

  function handleOpenCamera() {
    SheetManager.hide(props.sheetId)
    // Before opening camera modal, we need to wait for SheetManager to hide the sheet
    setTimeout(() => {
      props.payload?.openCamera()
    }, 300)
  }

  return (
    <BottomSheet>
      <Pressable onPress={handleOpenImageViewer}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Image className={'size-6 text-text-tertiary'} />
            <Text className={'text-base text-text-primary'}>{t('ui:chooseFromLibrary')}</Text>
          </View>
        )}
      </Pressable>
      <Pressable onPress={handleOpenCamera}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Camera className={'size-6 text-text-tertiary'} />
            <Text className={'text-base text-text-primary'}>{t('ui:takePhoto')}</Text>
          </View>
        )}
      </Pressable>
      <Pressable onPress={() => SheetManager.hide(props.sheetId)}>
        {({ pressed }) => (
          <View className={cn('flex-row gap-3 px-4 py-3', pressed && 'bg-background-secondary')}>
            <Close className={'size-6 text-text-tertiary'} />
            <Text className={'text-base text-text-primary'}>{t('ui:cancel')}</Text>
          </View>
        )}
      </Pressable>
    </BottomSheet>
  )
}
